import { faFilePdf, faImage, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect, useState } from 'react';
import { Button, Tooltip } from 'reactstrap';
import Spinner from 'reactstrap/lib/Spinner';
import UncontrolledTooltip from 'reactstrap/lib/UncontrolledTooltip';
import { useAuth0 } from '../../auth0/reactAuth0Spa';
import { checkLoginForError, formatBearerToken, sanitizeFilename, swalErrorMessage } from '../../Common.functions';
import { DepartmentContext } from '../../DepartmentWrapper';
import { fetchDataAgnostic } from '../../Services/dataApi';
import { popoverModifiers } from 'enums';
import RezRateSideDrawer from '../RezRATE/Common/RezRateSideDrawer/RezRateSideDrawer';
import { truncate } from '../../Services/candidates';

const FileViewer = (props) => {
  const [uri, setUri] = useState(null);
  const [MimeType, setMimeType] = useState(null);
  const [info, setInfo] = useState({});
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState();
  const [showTimedTooltips, setShowTimedTooltips] = useState(false);
  const [myToken, setToken] = useState();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const dContext = useContext(DepartmentContext);

  const widthToSwitchToMobile = 768;

  useEffect(() => {
    getCandidateDetails();
    // getFile(props.match.params);

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (documents && documents.length > 0) {
      setShowTimedTooltips(true);

      setTimeout(() => {
        setShowTimedTooltips(false);
      }, 4000);
    }
  }, [documents]);

  useEffect(() => {
    if (info) {
      document.title = `${info.LastName || ''}, ${info.FirstName || ''} | ${
        selectedDocument ? selectedDocument.DocumentTypeName : 'No Document Name'
      }`;
    }
  }, [info, selectedDocument]);

  const { getTokenSilently, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (!selectedDocument) return;
    const { pk_File, fk_Department, fk_Candidate, Name, fk_DocumentType, MimeType } = selectedDocument;
    getTokenSilently()
      .then((token) => {
        setToken(token);
        fetchDataAgnostic(
          'files/candidateFile',
          {
            pk_File,
            pk_DocumentType: fk_DocumentType,
            fileName: Name,
            pk_Department: fk_Department,
          },
          formatBearerToken(token),
        )
          .then((result) => {
            if (result && result.data && result.data.uri) {
              setUri(result.data.uri);
            } else {
              swalErrorMessage();
            }
          })
          .catch((err) => {
            swalErrorMessage();
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  }, [selectedDocument]);

  const getCandidateDetails = () => {
    const { pk_File, pk_DocumentType, fileName, pk_Candidate } = props.match.params;
    const query = new URLSearchParams(props.location && props.location.search ? props.location.search : '');
    const pk_DepartmentFromQuery = query.get('pk_Department');
    const pk_DepartmentToUse = pk_DepartmentFromQuery || (dContext && dContext.department && dContext.department.pk_Department);
    // Opened from the Evaluate tab: show the evaluator's view (admins receive hidden-type documents with Hide set).
    const isEvaluateContext = query.get('context') === 'evaluator';
    if (pk_Candidate != null) {
      setIsLoading(true);
      getTokenSilently()
        .then((token) => {
          if (!pk_DepartmentToUse) {
            setIsLoading(false);
            swalErrorMessage('Unable to load document: missing department context.');
            return;
          }
          fetchDataAgnostic(
            'department/candidate',
            { pk_Candidate, pk_Department: pk_DepartmentToUse },
            formatBearerToken(token),
          )
            .then((result) => {
              const newDocuments = (result.data.Documents || []).filter((d) => !(isEvaluateContext && d.Hide));
              const defaultDocument = newDocuments.find((d) => {
                return d.pk_File == pk_File;
              });
              if (defaultDocument) {
                setSelectedDocument(defaultDocument);
              }
              setInfo(result.data);
              setDocuments(newDocuments);
              setIsLoading(false);
            })
            .catch((err) => {
              setIsLoading(false);
            });
        })
        .catch((err) => {
          setIsLoading(false);
          checkLoginForError({ err, loginWithRedirect });
        });
    } else {
    }
  };

  const processIcon = (type) => {
    let icon = null;

    if (type.indexOf('/pdf') >= 0) {
      icon = faFilePdf;
    } else if (type.indexOf('image') >= 0) {
      icon = faImage;
    }

    return icon;
  };

  const renderTopBar = (isMobile = false) => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          height: isMobile ? 60 : 80,
          padding: 5,
          paddingLeft: isMobile ? 10 : 30,
          paddingRight: isMobile ? 10 : 30,
          marginBottom: isMobile ? 10 : 30,
          borderBottom: '1px solid grey',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ fontSize: isMobile ? 18 : 30, fontWeight: 'bold' }}>{`${
            info ? `${info.LastName || ''}, ${info.FirstName || ''}` : ''
          }`}</div>
          <div style={{ fontSize: isMobile ? 12 : 15 }}>
            <span style={{ fontWeight: 'bold' }}>{selectedDocument ? selectedDocument.DocumentTypeName : 'None'}</span>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'right' }}>
            <Button
              disabled={!selectedDocument}
              color="primary"
              size={isMobile ? 'sm' : undefined}
              onClick={() => {
                document.getElementById(`fileDownload`).click();
              }}
            >
              Download
            </Button>

            <a
              id="fileDownload"
              style={{ visibility: 'hidden' }}
              href={uri ? uri : ''}
              target="_blank" rel="noopener noreferrer"
              download={`${info.LastName}_${info.FirstName}_${
                selectedDocument ? selectedDocument.DocumentTypeName : ''
              }`}
            >
              Download
            </a>
          </div>
        </div>
      </div>
    );
  };

  const renderDocumentList = (isDark = false) => {
    if (!documents || documents.length === 0) {
      return null;
    }

    return documents.map((d, i) => {
      const isSelected = selectedDocument && selectedDocument.pk_File === d.pk_File;

      return (
        <div
          key={d.pk_File}
          onClick={() => {
            setSelectedDocument(d);
            // Auto-close drawer on mobile after selection
            if (windowWidth < widthToSwitchToMobile) {
              setDrawerOpen(false);
            }
          }}
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '12px 15px',
            cursor: 'pointer',
            backgroundColor: isSelected
              ? isDark
                ? '#555'
                : 'var(--rr-primary-soft)'
              : isDark
              ? '#333'
              : i % 2 === 0
              ? 'var(--rr-surface-stripe)'
              : 'var(--rr-surface)',
            borderBottom: '1px solid ' + (isDark ? '#555' : '#e0e0e0'),
            gap: '12px',
            transition: 'background-color 0.2s ease',
          }}
          onMouseEnter={(e) => {
            if (!isSelected) {
              e.currentTarget.style.backgroundColor = isDark ? '#444' : '#e8f4f8';
            }
          }}
          onMouseLeave={(e) => {
            if (!isSelected) {
              e.currentTarget.style.backgroundColor = isDark ? '#333' : i % 2 === 0 ? 'var(--rr-surface-stripe)' : 'var(--rr-surface)';
            }
          }}
        >
          <FontAwesomeIcon
            icon={processIcon(d.MimeType)}
            style={{ fontSize: 20, minWidth: 20, color: isDark ? 'white' : 'inherit' }}
          />
          <span
            style={{
              fontSize: 14,
              color: isDark ? 'white' : 'black',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {truncate(d.DocumentTypeName || 'Unknown Document Type', 30)}
          </span>
        </div>
      );
    });
  };

  // Desktop Layout
  if (windowWidth >= widthToSwitchToMobile) {
    return (
      <div>
        {renderTopBar(false)}
        <div style={{ height: 'calc(100vh - 43px)' }}>
          {/* {correctViewer()} */}
          {/* <div style={{ fontWeight: 'bold', justifyContent: 'center', textAlign: 'center', width: '30%' }}>Documents</div> */}
          <div style={{ display: 'flex', flexDirection: 'row', height: '80vh' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '10%',
                maxWidth: 80,
                minWidth: 70,
                paddingLeft: 20,
              }}
            >
              <div>
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflowY: 'auto' }}>
                  {documents && documents.length > 1
                    ? documents.map((d, i) => {
                        return (
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              // marginRight: 10,
                              // marginLeft: 10,
                              paddingTop: 10,
                              // paddingLeft: 10,
                              cursor: 'pointer',
                              borderBottom: '1px grey solid',
                              backgroundColor:
                                selectedDocument && selectedDocument.pk_File == d.pk_File
                                  ? 'var(--rr-primary-soft)'
                                  : i % 2 == 0
                                  ? 'var(--rr-surface-stripe)'
                                  : 'var(--rr-surface)',
                            }}
                            onClick={() => {
                              setSelectedDocument(d);
                            }}
                          >
                            <div
                              id={`file_${i}`}
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%',

                                paddingBottom: 10,
                              }}
                            >
                              <FontAwesomeIcon icon={processIcon(d.MimeType)} style={{ fontSize: 20 }} size={30} />
                            </div>
                            <Tooltip
                              isOpen={showTimedTooltips}
                              target={`file_${i}`}
                              placement="right"
                              flip={false}
                              modifiers={popoverModifiers}
                            >
                              {d.DocumentTypeName || 'Unknown Document Type'}
                            </Tooltip>
                            <UncontrolledTooltip
                              target={`file_${i}`}
                              placement="right"
                              flip={false}
                              modifiers={popoverModifiers}
                            >
                              {d.DocumentTypeName || 'Unknown Document Type'}
                            </UncontrolledTooltip>
                          </div>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '90%', paddingRight: 20 }}>
              {selectedDocument ? (
                // selectedDocument.MimeType.indexOf('image') >= 0 ? (
                //   <image src={selectedDocument.FullUrl} height={'100%'} width={'100%'} />
                // ) :
                //   (
                <iframe src={uri} title={selectedDocument.Name} style={{ height: '100%', width: '100%' }} />
              ) : (
                // )
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    height: '70vh',
                    width: '100%',
                    backgroundColor: '#d6d6d6',
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignSelf: 'center',
                    fontWeight: 'bold',
                  }}
                >
                  {' '}
                  {isLoading ? <Spinner color="primary" size="sm" style={{ marginRight: 10 }} /> : 'Select a Document'}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Mobile Layout
  return (
    <div>
      {renderTopBar(true)}

      <RezRateSideDrawer
        isOpen={drawerOpen}
        setIsOpen={setDrawerOpen}
        options={{
          width: '280px',
          position: 'left',
          backgroundColor: '#333',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100vh - 40px)',
            overflowY: 'auto',
          }}
        >
          <div
            style={{
              padding: '15px 0',
              borderBottom: '1px solid #555',
              color: 'white',
              fontWeight: 'bold',
              textAlign: 'center',
              fontSize: 16,
            }}
          >
            Documents
          </div>
          {renderDocumentList(true)}
        </div>
      </RezRateSideDrawer>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 110px)',
          padding: '10px',
        }}
      >
        {selectedDocument ? (
          <iframe
            src={uri}
            title={selectedDocument.Name}
            style={{
              height: '100%',
              width: '100%',
              border: '1px solid #ccc',
              borderRadius: '4px',
            }}
          />
        ) : (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              backgroundColor: '#f5f5f5',
              borderRadius: '4px',
              fontWeight: 'bold',
              color: '#666',
            }}
          >
            {isLoading ? <Spinner color="primary" size="sm" style={{ marginRight: 10 }} /> : 'Select a Document'}
          </div>
        )}
      </div>
    </div>
  );
};

export default FileViewer;
